export default __webpack_public_path__ + "static/media/arrow-right.b05dce79.svg";